<template>
    <div class="observer"/>
</template>

<script>
export default {
    /**
     * Source + blog article about observers:
     * https://vueschool.io/articles/vuejs-tutorials/build-an-infinite-scroll-component-using-intersection-observer-api/
     */

    props: {
        options: {
            type:    Object,
            default: () => {}
        }
    },
    data () {
        return {
            observer: null,
        }
    },
    mounted () {
        this.observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                this.$emit('intersect')
            }
        }, this.options)

        this.observer.observe(this.$el)
    },
    destroyed () {
        this.observer.disconnect()
    },
}
</script>
